import { teamLogos } from "../assets/teamImages"
import { NCAAB_ESPN_TEAM_IDS } from "./ncaabEspnTeamIds"

const NCAA_BASKETBALL_FALLBACK_IMG =
  "https://cdn.worldvectorlogo.com/logos/ncaa-basketball.svg"

const ESPN_TEAM_MAPPINGS = {
  // NBA
  "Boston Celtics": { abbr: "BOS", league: "nba" },
  "Brooklyn Nets": { abbr: "BKN", league: "nba" },
  "New York Knicks": { abbr: "NYK", league: "nba" },
  "Philadelphia 76ers": { abbr: "PHI", league: "nba" },
  "Toronto Raptors": { abbr: "TOR", league: "nba" },
  "Chicago Bulls": { abbr: "CHI", league: "nba" },
  "Cleveland Cavaliers": { abbr: "CLE", league: "nba" },
  "Detroit Pistons": { abbr: "DET", league: "nba" },
  "Indiana Pacers": { abbr: "IND", league: "nba" },
  "Milwaukee Bucks": { abbr: "MIL", league: "nba" },
  "Atlanta Hawks": { abbr: "ATL", league: "nba" },
  "Charlotte Hornets": { abbr: "CHA", league: "nba" },
  "Miami Heat": { abbr: "MIA", league: "nba" },
  "Orlando Magic": { abbr: "ORL", league: "nba" },
  "Washington Wizards": { abbr: "WAS", league: "nba" },
  "Denver Nuggets": { abbr: "DEN", league: "nba" },
  "Minnesota Timberwolves": { abbr: "MIN", league: "nba" },
  "Oklahoma City Thunder": { abbr: "OKC", league: "nba" },
  "Portland Trail Blazers": { abbr: "POR", league: "nba" },
  "Utah Jazz": { abbr: "UTA", league: "nba" },
  "Golden State Warriors": { abbr: "GSW", league: "nba" },
  "Los Angeles Clippers": { abbr: "LAC", league: "nba" },
  "Los Angeles Lakers": { abbr: "LAL", league: "nba" },
  "Phoenix Suns": { abbr: "PHX", league: "nba" },
  "Sacramento Kings": { abbr: "SAC", league: "nba" },
  "Dallas Mavericks": { abbr: "DAL", league: "nba" },
  "Houston Rockets": { abbr: "HOU", league: "nba" },
  "Memphis Grizzlies": { abbr: "MEM", league: "nba" },
  "New Orleans Pelicans": { abbr: "NOP", league: "nba" },
  "San Antonio Spurs": { abbr: "SAS", league: "nba" },
  // NFL
  "Kansas City Chiefs": { abbr: "KC", league: "nfl" },
  "Detroit Lions": { abbr: "DET", league: "nfl" },
  "Philadelphia Eagles": { abbr: "PHI", league: "nfl" },
  "Dallas Cowboys": { abbr: "DAL", league: "nfl" },
  "Buffalo Bills": { abbr: "BUF", league: "nfl" },
  "San Francisco 49ers": { abbr: "SF", league: "nfl" },
  "Baltimore Ravens": { abbr: "BAL", league: "nfl" },
  "Miami Dolphins": { abbr: "MIA", league: "nfl" },
  "Green Bay Packers": { abbr: "GB", league: "nfl" },
  "Minnesota Vikings": { abbr: "MIN", league: "nfl" },
  "Pittsburgh Steelers": { abbr: "PIT", league: "nfl" },
  "Los Angeles Rams": { abbr: "LAR", league: "nfl" },
  "Seattle Seahawks": { abbr: "SEA", league: "nfl" },
  "Tampa Bay Buccaneers": { abbr: "TB", league: "nfl" },
  "Cincinnati Bengals": { abbr: "CIN", league: "nfl" },
  "New England Patriots": { abbr: "NE", league: "nfl" },
  "Los Angeles Chargers": { abbr: "LAC", league: "nfl" },
  "Cleveland Browns": { abbr: "CLE", league: "nfl" },
  "Denver Broncos": { abbr: "DEN", league: "nfl" },
  "Indianapolis Colts": { abbr: "IND", league: "nfl" },
  "Atlanta Falcons": { abbr: "ATL", league: "nfl" },
  "Houston Texans": { abbr: "HOU", league: "nfl" },
  "Jacksonville Jaguars": { abbr: "JAX", league: "nfl" },
  "Las Vegas Raiders": { abbr: "LV", league: "nfl" },
  "New Orleans Saints": { abbr: "NO", league: "nfl" },
  "New York Giants": { abbr: "NYG", league: "nfl" },
  "New York Jets": { abbr: "NYJ", league: "nfl" },
  "Tennessee Titans": { abbr: "TEN", league: "nfl" },
  "Washington Commanders": { abbr: "WSH", league: "nfl" },
  "Arizona Cardinals": { abbr: "ARI", league: "nfl" },
  "Carolina Panthers": { abbr: "CAR", league: "nfl" },
  "Chicago Bears": { abbr: "CHI", league: "nfl" },
  // MLB
  "Arizona Diamondbacks": { abbr: "ari", league: "mlb" },
  "Atlanta Braves": { abbr: "atl", league: "mlb" },
  "Baltimore Orioles": { abbr: "bal", league: "mlb" },
  "Boston Red Sox": { abbr: "bos", league: "mlb" },
  "Chicago Cubs": { abbr: "chc", league: "mlb" },
  "Chicago White Sox": { abbr: "cws", league: "mlb" },
  "Cincinnati Reds": { abbr: "cin", league: "mlb" },
  "Cleveland Guardians": { abbr: "cle", league: "mlb" },
  "Colorado Rockies": { abbr: "col", league: "mlb" },
  "Detroit Tigers": { abbr: "det", league: "mlb" },
  "Houston Astros": { abbr: "hou", league: "mlb" },
  "Kansas City Royals": { abbr: "kc", league: "mlb" },
  "Los Angeles Angels": { abbr: "laa", league: "mlb" },
  "Los Angeles Dodgers": { abbr: "lad", league: "mlb" },
  "Miami Marlins": { abbr: "mia", league: "mlb" },
  "Milwaukee Brewers": { abbr: "mil", league: "mlb" },
  "Minnesota Twins": { abbr: "min", league: "mlb" },
  "New York Mets": { abbr: "nym", league: "mlb" },
  "New York Yankees": { abbr: "nyy", league: "mlb" },
  "Oakland Athletics": { abbr: "oak", league: "mlb" },
  "Athletics": { abbr: "oak", league: "mlb" },
  "Philadelphia Phillies": { abbr: "phi", league: "mlb" },
  "Pittsburgh Pirates": { abbr: "pit", league: "mlb" },
  "San Diego Padres": { abbr: "sd", league: "mlb" },
  "San Francisco Giants": { abbr: "sf", league: "mlb" },
  "Seattle Mariners": { abbr: "sea", league: "mlb" },
  "St. Louis Cardinals": { abbr: "stl", league: "mlb" },
  "Tampa Bay Rays": { abbr: "tb", league: "mlb" },
  "Texas Rangers": { abbr: "tex", league: "mlb" },
  "Toronto Blue Jays": { abbr: "tor", league: "mlb" },
  "Washington Nationals": { abbr: "wsh", league: "mlb" },
}

const SPORT_TO_LOGO_GROUP = {
  americanfootball_nfl: "nfl",
  americanfootball_ncaaf: "ncaaf",
  basketball_nba: "nba",
  basketball_ncaab: "ncaab",
  basketball_wncaab: "ncaab",
  baseball_mlb: "mlb",
}

const normalizeTeamName = (name) => {
  if (!name) return ""
  return name
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]/g, "")
    .trim()
}

const stripLadyTeamPrefix = (name) =>
  name.replace(/^\s*(lady|ladies)\s+/i, "").trim()

const getEspnNcaabLogoUrl = (teamName) => {
  if (!teamName) return null
  const trimmed = teamName.trim()
  const variants = [trimmed, stripLadyTeamPrefix(trimmed)]

  for (const v of variants) {
    const id = NCAAB_ESPN_TEAM_IDS[v]
    if (id != null) {
      return `https://a.espncdn.com/i/teamlogos/ncaa/500/${id}.png`
    }
  }

  const normalizedSearch = normalizeTeamName(stripLadyTeamPrefix(trimmed))
  if (!normalizedSearch) return null

  const entries = Object.entries(NCAAB_ESPN_TEAM_IDS)
  const normMatch = entries.find(([k]) => normalizeTeamName(k) === normalizedSearch)
  if (normMatch) {
    return `https://a.espncdn.com/i/teamlogos/ncaa/500/${normMatch[1]}.png`
  }

  const partials = entries.filter(([k]) => {
    const n = normalizeTeamName(k)
    return n.includes(normalizedSearch) || normalizedSearch.includes(n)
  })
  if (partials.length) {
    partials.sort(
      (a, b) => normalizeTeamName(b[0]).length - normalizeTeamName(a[0]).length
    )
    const [, id] = partials[0]
    return `https://a.espncdn.com/i/teamlogos/ncaa/500/${id}.png`
  }

  return null
}

const getLeagueGroup = (sportKey = "") => {
  return SPORT_TO_LOGO_GROUP[sportKey] || null
}

const getDirectLogo = (teamName, sportKey) => {
  const group = getLeagueGroup(sportKey)
  if (!group || !teamLogos[group]) return null
  return teamLogos[group][teamName] || null
}

const getFuzzyLogo = (teamName, sportKey) => {
  const group = getLeagueGroup(sportKey)
  if (!group || !teamLogos[group]) return null

  const normalizedSearch = normalizeTeamName(teamName)
  const entries = Object.entries(teamLogos[group])

  const exact = entries.find(([name]) => normalizeTeamName(name) === normalizedSearch)
  if (exact) return exact[1]

  const partial = entries.find(([name]) => {
    const normalized = normalizeTeamName(name)
    return normalized.includes(normalizedSearch) || normalizedSearch.includes(normalized)
  })
  if (partial) return partial[1]

  return null
}

export const getTeamLogoWithFallback = (teamName, sportKey) => {
  if (!teamName) return ""

  const isCollegeHoops =
    sportKey === "basketball_ncaab" || sportKey === "basketball_wncaab"

  const espnInfo = ESPN_TEAM_MAPPINGS[teamName]
  if (espnInfo) {
    return `https://a.espncdn.com/i/teamlogos/${espnInfo.league}/500/${espnInfo.abbr}.png`
  }

  if (sportKey === "americanfootball_ncaaf") {
    return "https://img.icons8.com/ios/100/american-football-ball.png"
  }

  if (isCollegeHoops) {
    const ncaabEspn = getEspnNcaabLogoUrl(teamName)
    if (ncaabEspn) return ncaabEspn
  }

  const direct = getDirectLogo(teamName, sportKey)
  if (direct) return direct

  const fuzzy = getFuzzyLogo(teamName, sportKey)
  if (fuzzy) return fuzzy

  if (isCollegeHoops) {
    return NCAA_BASKETBALL_FALLBACK_IMG
  }

  return `https://ui-avatars.com/api/?name=${encodeURIComponent(teamName)}&background=1f2937&color=ffffff&size=96`
}

